// Environment variables for React app
export const env = {
  RESEND_API_KEY: process.env.REACT_APP_RESEND_API_KEY || '',
  CONTACT_EMAIL: process.env.REACT_APP_CONTACT_EMAIL || 'roastmylisting@msg.sellersynapse.com',
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL || 'https://yatxsbtzttwivilywuyo.supabase.co',
  SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlhdHhzYnR6dHR3aXZpbHl3dXlvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0MTM0MTAsImV4cCI6MjA1Nzk4OTQxMH0.nfcTk-YMIoVixWJpzQiWoqegrU3Azno-27w0OhWeZRI',
  AMAZON_AFFILIATE_TAG: process.env.REACT_APP_AMAZON_AFFILIATE_TAG || 'roastmylistin-20',
  WEBHOOK_ENDPOINT: process.env.REACT_APP_WEBHOOK_ENDPOINT || 'https://hook.us1.make.com/clzdwmx44ovmoqtvqrap11pg9vbry8sh',
  WEBHOOK_MOCK_MODE: process.env.REACT_APP_WEBHOOK_MOCK_MODE === 'true',
  GOOGLE_ANALYTICS_ID: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-D8NG7DLPYW',
  LINKEDIN_PARTNER_ID: process.env.REACT_APP_LINKEDIN_PARTNER_ID || '6970922',
  META_PIXEL_ID: process.env.REACT_APP_META_PIXEL_ID || '536525029469786',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || window.location.origin,
  DEBUG_MODE: process.env.REACT_APP_DEBUG_MODE === 'true',
};
